var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isWorkList)?_c('cts-work-list-factory'):(_vm.isVersionList)?_c('cts-version-list'):_c('cts-toc-list')}
var staticRenderFns = []

export { render, staticRenderFns }